import { ref } from 'vue'
import { defineStore } from 'pinia'

export const usePageLoadingStore = defineStore('pageLoading', () => {
  const isLoading = ref(false)
  let delayTimer = null

  // Small delay to avoid flashing on fast navigations (cached getUser, etc.).
  // Only paints the overlay if the operation is still in flight after `delay` ms.
  const start = (delay = 500) => {
    if (delayTimer || isLoading.value) return
    delayTimer = setTimeout(() => {
      isLoading.value = true
      delayTimer = null
    }, delay)
  }

  const stop = () => {
    if (delayTimer) {
      clearTimeout(delayTimer)
      delayTimer = null
    }
    isLoading.value = false
  }

  // The branded full-page loader. Separate from `isLoading` because that one is the quiet spinner
  // the router puts up between routes; this one owns the screen.
  //
  // `brand` is passed in rather than read from the active retailer: a panel switch shows the loader
  // of the panel it is heading for, not the one the store still holds. `fadeIn` false means the veil
  // is already on screen and this call is only taking it over, so fading it in again would dip back
  // to the page underneath.
  const fullPage = ref(null)

  const startFullPage = (message, brand, { fadeIn = true } = {}) => {
    fullPage.value = { message, brand, fadeIn }
  }

  const stopFullPage = () => {
    fullPage.value = null
  }

  return { isLoading, start, stop, fullPage, startFullPage, stopFullPage }
})
